<ng-template #secondUserMenu let-ref>
  <section class="user-menu">
    <ng-container>
      <div (click)="contextMenuAction(contextMenuActionType.PASTE)">
        <ng-container i18n="@@app.paste">Paste</ng-container>
      </div>
      <div (click)="contextMenuAction(contextMenuActionType.CANCEL)">
        <ng-container i18n="@@app.cancel">Cancel</ng-container>
      </div>
    </ng-container>
  </section>
</ng-template>
